module.exports = __webpack_public_path__ + "static/nxrt-rail_bg-37b3224c9a2746c436e7c4640fa2fd2c.jpg";